import {
  FETCH_ROLE_DATA_LIST_FAILED,
  FETCH_ROLE_DATA_LIST_SUCCESS,
  FETCH_ROLE_DATA_LIST_LOADING,
  FETCH_MENU_SUCCESS,
  FETCH_ROLE_INFO_LOADING,
  FETCH_ROLE_INFO_SUCCESS,
  FETCH_ROLE_INFO_FAILED,
} from "../actions/manageRole";

const defVal = {
  dataListLoading: false,
  dataList: [],
  dataListTotal: 0,
  // 角色权限列表
  menu: [],
  // 当前登录用户角色权限
  currentRoleInfo: {},
  // 获取当前登录角色权限接口响应状态
  fetchCurrentRoleInfoLoading: true,
  // 是否展示无权限界面
  isShowNoMenu: false,
  // 当前默认的控制权限
  showContrl: {
    '0000000000001': false,  // 开发者信息
    '0000000000002': false,  // 常用管理
    '0000000000003': false,  // 产品管理
    '0000000000004': false,  // 用户查询
    '0000000000005': false,  // 设备查询
    '0000000000006': false,  // 客户分析
    '0000000000007': false,  // 数据分析
    '0000000000008': false,  // 账号管理
    '0000000000009': false,  // 角色管理
    '0000000000010': false,  // 品类管理
    '0000000000011': false,  // 创建产品
    '0000000000012': false,  // 查看所有PID
    '0000000000013': false,  // 功能定义编辑
    '0000000000014': false,  // 界面配置编辑
    '0000000000015': false,  // 固件管理编辑
    '0000000000016': false,  // 产品发布
    '0000000000017': false,  // 固件升级
  }
};

export default (state = defVal, action) => {
  switch (action.type) {
    case FETCH_ROLE_DATA_LIST_LOADING:
      return Object.assign({}, state, {
        dataListLoading: true,
      });
    case FETCH_ROLE_DATA_LIST_SUCCESS:
      return Object.assign({}, state, {
        dataListLoading: false,
        dataList: action.dataList,
        dataListTotal: action.dataListTotal,
      });
    case FETCH_ROLE_DATA_LIST_FAILED:
      return Object.assign({}, state, {
        dataListLoading: false,
      });
    case FETCH_MENU_SUCCESS:
      return Object.assign({}, state, {
        menu: action.menu,
      });
    case FETCH_ROLE_INFO_LOADING:
      return Object.assign({}, state, {
        fetchCurrentRoleInfoLoading: true,
      });
    case FETCH_ROLE_INFO_SUCCESS:
      return Object.assign({}, state, {
        fetchCurrentRoleInfoLoading: false,
        currentRoleInfo: action.currentRoleInfo,
        showContrl: action.showContrl,
        isShowNoMenu: action.isShowNoMenu,
      });
    case FETCH_ROLE_INFO_FAILED:
      return Object.assign({}, state, {
        fetchCurrentRoleInfoLoading: false,
      });

    default:
      return state;
  }
};
